import React, { useState, useEffect, useCallback, useMemo, useContext} from 'react';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { inputOnlyNumbersWithDecimals, inputOnlyNumbers } from '../../../utils/CommonUtilities.js';
import QRCode from 'qrcode';
import { useDropzone } from 'react-dropzone';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config.js';
import useNotification from '../../../hooks/useNotification.js';

const baseStyle = {
    //flex: 1,
    width: '230px',
    height: '90px',
    //marginLeft: '50px',
    display: 'flex',
    fontSize: '14px',
    flexDirection: 'column',
    alignItems: 'center',

    //padding: '50px',
    borderWidth: 3,
    borderRadius: 5,
    borderColor: '#aaaaaa',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

async function createQRCode(lat, lon) {
    try {
        let urlQrCode = `https://www.google.com/maps?saddr=My+Location&daddr=${lat},${lon}`;
        let result = await QRCode.toDataURL(urlQrCode);
        
        return result;
    } catch (err) {
        console.error(err.message)
    }
}

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function ManagePoiDialog(props) {
    const auth = useContext(AuthContext);
    const [dialogMode, setDialogMode] = useState('');
    const { notificationSuccess, notificationError, notificationInfo } = useNotification();
    const [idEntita, setIdEntita] = useState('');
    const [city, setCity] = useState('');

    const [itname, setItname] = useState('');
    const [enname, setEnname] = useState('');
    const [lat, setLat] = useState('');
    const [lon, setLon] = useState('');
    //const [nearPanels, setNearPanels] = useState('');
    const [itdescription, setItdescription] = useState('');
    const [endescription, setEndescription] = useState('');
    const [base64Image, setBase64ImageValue] = useState(null);
    
    const [qrCodeImage, setQrCodeImage] = useState(null);

    const [originalItname, setOriginalItname] = useState('');
    const [originalEnname, setOriginalEnname] = useState('');
    const [originalLat, setOriginalLat] = useState('');
    const [originalLon, setOriginalLon] = useState('');
    const [originalItdescription, setOriginalItdescription] = useState('');
    const [originalEndescription, setOriginalEndescription] = useState('');
    const [originalBase64Image, setOriginalBase64Image] = useState(null);

    useEffect(() => {
        async function init(){
            if(props.openManagePoiDialog==='mod'){
                setIdEntita(props.lastCellData?.idEntita.S);
                setCity(props.lastCellData?.city.S);
                setDialogMode('mod');
                getPoi(props.lastCellData?.idEntita.S, props.lastCellData?.city.S);
            }else{
                setIdEntita('');
                setCity('');
                setDialogMode('ins');

                setItname('');
                setEnname('');
                setLat('');
                setLon('');
                //setNearPanels('');
                setItdescription('');
                setEndescription('');
                setBase64ImageValue(null);
                setQrCodeImage(null);
                setOriginalBase64Image(null);
            }
        }
        init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.openManagePoiDialog])

    const getPoi = async(forcePassId = false, forcePassCity = false) => {
        try {
            const params = {
                idEntita: forcePassId ? forcePassId : idEntita,
                city: forcePassCity ? forcePassCity : city
            };

            const axiosParams = {
                url: '/get-poi',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);

            let itemData = response.data.result.Item;

            setItname(itemData?.itname?.S || '');
            setEnname(itemData?.enname?.S || '');
            setLat(itemData?.lat?.S || '');
            setLon(itemData?.lon?.S || '');
            //setNearPanels(itemData?.nearPanels?.SS.join(', ') || '');
            setItdescription(itemData?.itdescription?.S || '');
            setEndescription(itemData?.endescription?.S || '');

            if(itemData?.lat?.S && itemData?.lon?.S){
                let qrcode = await createQRCode(itemData.lat.S, itemData.lon.S);
                setQrCodeImage(qrcode);
            }

            setBase64ImageValue(itemData?.photo?.S || '');

            setOriginalItname(itemData?.itname?.S || '');
            setOriginalEnname(itemData?.enname?.S || '');
            setOriginalLat(itemData?.lat?.S || '');
            setOriginalLon(itemData?.lon?.S || '');
            setOriginalItdescription(itemData?.itdescription?.S || '');
            setOriginalEndescription(itemData?.endescription?.S || '');
            setOriginalBase64Image(itemData?.photo?.S || '');
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const modPoi = async() => {
        try {
            const essentialData = {
                idEntita: idEntita,
                city: city
            }

            const data = {
                itname: itname === originalItname ? '' : itname,
                enname: enname === originalEnname ? '' : enname,
                lat: lat === originalLat ? '' : lat,
                lon: lon === originalLon ? '' : lon,
                itdescription: itdescription === originalItdescription ? '' : itdescription,
                endescription: endescription === originalEndescription ? '' : endescription,
            }

            const dataToPass = {
                ExpressionAttributeNames: {},
                ExpressionAttributeValues: {},
                UpdateExpression: "SET",
            };
            
            let dataKeys = Object.keys(data);
            for (let index = 0; index < dataKeys.length; index++) {
                const element = dataKeys[index];
                
                if(!data[element]){
                    delete data[element];
                }else{
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"S": data[element]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`;
                }
            }

            if(!Object.keys(data).length && base64Image === originalBase64Image){
                //se non ci sono chiavi non è cambiato nulla e ritorno
                return;
            }
            let form = new FormData();

            form.append('essentialData', JSON.stringify(essentialData));

            if(base64Image !== originalBase64Image){
                form.append('file', base64Image);
            }

            if(Object.keys(data).length){
                form.append('data', JSON.stringify(dataToPass))
            }

            const axiosParams = {
                url: '/mod-poi',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: form
            };
            const response = await axios(axiosParams);
            notificationSuccess('Punto di interesse Aggiornato');

            let newOriginalItems = response.data.responseUpdate.Attributes

            setOriginalItname(newOriginalItems?.itname?.S || '');
            setOriginalEnname(newOriginalItems?.enname?.S || '');
            setOriginalLat(newOriginalItems?.lat?.S || '');
            setOriginalLon(newOriginalItems?.lon?.S || '');
            setOriginalItdescription(newOriginalItems?.itdescription?.S || '');
            setOriginalEndescription(newOriginalItems?.endescription?.S || '');
            setOriginalBase64Image(newOriginalItems?.photo?.S || '');
            //per l'immagine devo resettare anche il corrente siccome il datatype è diverso
            setBase64ImageValue(newOriginalItems?.photo?.S || '');
            
            if(newOriginalItems?.lat?.S && newOriginalItems?.lon?.S){
                let qrcode = await createQRCode(newOriginalItems.lat.S, newOriginalItems.lon.S);
                setQrCodeImage(qrcode);
            }
            //setNearPanels(newOriginalItems?.nearPanels?.SS.join(', ') || '')

            props.getPois();
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const insPoi = async () => {
        try {
            if(!idEntita)return;

            const essentialData = {
                idEntita: idEntita,
            }

            const data = {
                itname: itname,
                enname: enname,
                lat: lat,
                lon: lon,
                itdescription: itdescription,
                endescription: endescription,
                city: props.city
            }

            let form = new FormData();

            form.append('essentialData', JSON.stringify(essentialData));

            if(base64Image !== originalBase64Image){
                form.append('file', base64Image);
            }

            if(Object.keys(data).length){
                form.append('data', JSON.stringify(data))
            }

            const axiosParams = {
                url: '/ins-poi',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: form
            };

            await axios(axiosParams);
            notificationSuccess('Punto di interesse Aggiunto');
            
            setIdEntita(idEntita);
            setCity(props.city);
            setDialogMode('mod');

            await props.getPois();
            await getPoi(idEntita, props.city);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const onDrop = useCallback(async(acceptedFiles) => {
        //devo prendere il file e renderlo base64 per poi storarlo
        if(acceptedFiles.length===0){
            notificationInfo('Sono accette solo immagini in formato .jpg');
            return;
        }
        setBase64ImageValue(acceptedFiles[0])
    }, []);

    const {
        /* acceptedFiles, */
        getRootProps,
        getInputProps,
        /* open, */
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({onDrop, accept: {'image/jpeg':['.jpg'] },  multiple: false});

    const dropZonestyle = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

    return (
        <Dialog className="dialog-mod-event" open={props.openManagePoiDialog} onClose={props.handleCloseManagePoiDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{dialogMode === 'ins' ? 'Inserisci punto di interesse' : originalItname + ' - ' + idEntita}</DialogTitle>
            <DialogContent>
                <div className='dialog-events-wrapper'>
                    <div className='dialog-events-wrapper-fields'>
                        {(dialogMode==='ins')&&(<div className="dialog-events-fields">
                            <TextField
                                className="dialog-identita required-field-bg"
                                id="dialog-identita"
                                label="Id Entità"
                                type="text"
                                value={idEntita}
                                onChange={(event) => {
                                    if(inputOnlyNumbers(event.target.value))setIdEntita(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                    maxWidth: "100px"
                                }}
                            />
                        </div>)}
                        <div className="dialog-events-fields">
                            <TextField
                                className="dialog-itname required-field-bg"
                                id="dialog-itname"
                                label="Nome-IT"
                                type="text"
                                value={itname}
                                onChange={(event) => {
                                    setItname(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%"
                                }}
                                inputProps={{
                                    maxLength: 40
                                }}
                            />
                            <TextField
                                className="dialog-enname required-field-bg"
                                id="dialog-enname"
                                label="Nome-EN"
                                type="text"
                                value={enname}
                                onChange={(event) => {
                                    setEnname(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                }}
                                inputProps={{
                                    maxLength: 40
                                }}
                            />
                        </div>
                        <Divider variant="middle"/>
                        <div className="dialog-events-fields">
                            <TextField
                                className="dialog-lat required-field-bg"
                                id="dialog-lat"
                                label="Latitudine"
                                type="text"
                                value={lat}
                                onChange={(event) => {
                                    if (inputOnlyNumbersWithDecimals(event.target.value)) setLat(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                    maxWidth: "250px"
                                }}
                            />

                            <TextField
                                className="dialog-lon required-field-bg"
                                id="dialog-lon"
                                label="Longitudine"
                                type="text"
                                value={lon}
                                onChange={(event) => {
                                    if (inputOnlyNumbersWithDecimals(event.target.value)) setLon(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                    maxWidth: "250px"
                                }}
                            />
                        </div>
                        <Divider variant="middle"/>
                        <div className="dialog-events-fields">
                            <div className='dialog-events-wrapper-fields-textarea'>
                                <label for="itdescrizione-textarea">Descrizione-IT</label>
                                <textarea
                                    className="notes-textarea"
                                    id="itdescrizione-textarea"
                                    rows={8}
                                    cols={50}
                                    maxLength={400}
                                    value={itdescription}
                                    onChange={(event) => setItdescription(event?.target.value)}
                                    placeholder='Descrizione-IT'
                                />
                                <div>{itdescription.length}/400</div>
                            </div>
                            <div className='dialog-events-wrapper-fields-textarea'>
                                <label for="endescrizione-textarea">Descrizione-EN</label>
                                <textarea
                                    className="notes-textarea"
                                    id="endescrizione-textarea"
                                    rows={8}
                                    cols={50}
                                    maxLength={400}
                                    value={endescription}
                                    onChange={(event) => setEndescription(event?.target.value)}
                                    placeholder='Descrizione-EN'
                                />
                                <div>{endescription.length}/400</div>
                            </div>
                        </div>
                    </div>
    
                    <div className='dialog-events-wrapper-fields-images'>
                        <img width="90" alt='qrCode' src={qrCodeImage}/>
                        <div className='dialog-events-wrapper-fields-image-section'>
                            <img width="134" height="100" alt='event-img' src={originalBase64Image !== base64Image ? URL.createObjectURL(base64Image) : 'data:image/jpg;base64, '+originalBase64Image}/>
                            <div className="dropBox" {...getRootProps({style: dropZonestyle})}>
                                <input {...getInputProps()} />
                                <p style={{textAlign: "center"}}>Clicca per caricare l'immagine</p>
                                <p style={{textAlign: "center"}}>Oppure trascina qui</p>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={() => dialogMode === 'ins' ? insPoi() : modPoi()}>
                    Salva
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseManagePoiDialog}>
                    Esci
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ManagePoiDialog